export const NEXUS_DEMO_DONE_USER_PROMPT = 'done'

/** @param {string} trimmed */
function normalizeDonePrompt(trimmed) {
  return trimmed.trim().replace(/\s+/g, ' ').toLowerCase()
}

/** @param {string} trimmed */
export function isNexusDemoDonePrompt(trimmed) {
  return normalizeDonePrompt(trimmed) === NEXUS_DEMO_DONE_USER_PROMPT
}

/**
 * @param {unknown[]} priorMessages
 * @returns {boolean}
 */
export function threadAwaitingNexusDemoDnsDone(priorMessages) {
  if (!Array.isArray(priorMessages) || priorMessages.length === 0) return false

  for (let i = priorMessages.length - 1; i >= 0; i--) {
    const message = priorMessages[i]
    if (!message || typeof message !== 'object') continue

    const role = /** @type {{ role?: string }} */ (message).role
    if (role !== 'assistant') continue

    const assistant = /** @type {{
      gcpHostingDeployCompleted?: boolean,
      nexusJourneySummaryCompleted?: boolean,
    }} */ (message)

    if (assistant.nexusJourneySummaryCompleted) return false
    if (assistant.gcpHostingDeployCompleted) return true
    return false
  }

  return false
}
